import { createResourceQuery } from './factory'

type Props = {
   organizationId?: string
   enabled?: boolean
}

export const useFiscalReport = createResourceQuery<'fiscal_report', Props>({
   queryKey: 'fiscal-report',
   view: 'fiscal_report',
   order: [{ column: 'created_at', ascending: false }],
   filters: (query, props) => {
      query.eq('organization_id', props.organizationId || '')
   },
})
